// @ts-nocheck

import { reduce as _reduce } from 'lodash';

import { BasketStatuses, BasketItemStatuses } from '../../../types/basket';

/**
 * Return the nextState corresponding to the BASKET_SUBMIT action
 *
 * @static
 * @param  {Object} state  The actual state
 * @return {Object}        Return the new state.
 */
const basketSubmit = (state) => {
  const { status, items } = state;
  if (status !== BasketStatuses.PENDING && status !== BasketStatuses.VALIDATED && status !== BasketStatuses.WAITING) {
    const nextItems = _reduce(
      items,
      (finalItems, item, key) => {
        if (item.status !== BasketItemStatuses.VALIDATED && item.status !== BasketItemStatuses.WAITING) {
          return {
            ...finalItems,
            [key]: {
              ...item,
              status: BasketItemStatuses.PENDING,
              betslipId: undefined,
              additionalMessage: undefined,
              error: undefined,
            },
          };
        }
        return finalItems;
      },
      {},
    );

    return {
      ...state,
      status: BasketStatuses.PENDING,
      items: nextItems,
      error: undefined,
      additionalMessage: undefined,
      betslipId: undefined,
    };
  }
  return state;
};

export default basketSubmit;
